export var COMPONENT_NAME_PREFIX = 'tcw-';
export var KEYSTROKE_DEBOUNCE_THRESHOLD = 500;
export var ICON_CLASS_NAME = 'tyler-icons';
export var VERSION = '0.51.2';
